<template>
  <div class="column cen-start bg-white conten">
    <p class="ft18 gray-3 textBox">请确认支付是否完成</p>
    <div class="payBtn column cen-center text-center ft16">
      <span class="over ilbk white" @click="succesPay">支付完成</span>
      <span class="noPay ilbk margin20-top" @click="close"
        >支付遇到问题，重新支付</span
      >
    </div>
    <div v-if="loddingFlag" class="lodding column cen-center">
      <span class="imgBox ilbk column cen-center">
        <img class="" src="../../assets/imgs/loading.gif" alt="" />
        <p class="ft16 white">正在检测支付结果...</p>
      </span>
    </div>
  </div>
</template>
<script>
import { getOrderByApplyNo } from "@/model/pay/payServer";
export default {
  name: "isPay",
  data() {
    return {
      timerSing: null,
      loddingFlag: false,
      orderNumber: "31231",
    };
  },
  created() {
    this.orderNumber = this.$route.query.orderNumber;
    this.timerSing = setInterval(() => {
      getOrderByApplyNo({ orderNumber: this.orderNumber }).then((data) => {
        if (data.data.state == 2) {
          window.clearInterval(this.timerSing);
          this.$router.replace({
            path: "/payResult",
            query: {
              isPay: true,
            },
          });
        }
      });
    }, 1500);
  },
  destroyed() {
    window.clearInterval(this.timerSing);
  },
  methods: {
    succesPay() {
      this.loddingFlag = true;
      setTimeout(() => {
        this.loddingFlag = false;
      }, 10000);
    },
    close() {
      this.$router.replace({
        path: "/pay",
        query: {
          cid: this.$route.query.cid,
        },
      });
    },
  },
};
</script>


<style lang="less" scoped>
.lodding {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  .imgBox {
    width: 222/20rem;
    height: 105/20rem;
    background: rgba(0, 0, 0, 0.6);
    // opacity:0.6;
    border-radius: 10px;
    img {
      width: 56/20rem;
    }
  }
}
.textBox {
  padding: 6rem 0 1.5rem 0;
}
.payBtn {
  padding: 0 2rem;
  box-sizing: border-box;
  width: 100%;
  .over {
    width: 100%;
    height: 45/20rem;
    line-height: 45/20rem;
    background: linear-gradient(
      90deg,
      rgba(253, 123, 49, 1),
      rgba(240, 130, 67, 1)
    );
    box-shadow: 0px 0px 7px 3px rgba(253, 123, 49, 0.43);
    border-radius: 5px;
  }
  .noPay {
    width: 100%;
    height: 45/20rem;
    line-height: 45/20rem;
    color: #f28141;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(242, 129, 65, 1);
    border-radius: 5px;
  }
}
</style>